"use strict";

/*==============================================================================
TRESTLE W008
TRESTLE CURATED RECOMMENDATIONS
MAIN ENGINE

Brand        : Diafemme®
Module       : W008
File         : TRESTLE_W008_Recommendations.js
Version      : 1.1

Responsibilities
----------------
• Read the saved W002 TRESTLE Profile
• Read W008 recommendation intelligence
• Read live Shopify product data supplied by Liquid
• Detect paid TRESTLE membership
• Calculate and display TRESTLE Special Price
• Display TRESTLE Saving badge
• Apply contextual gates
• Calculate product relevance
• Select up to 4 curated recommendations
• Maintain category diversity where practical
• Render Recommended for You
• Render Explore More
• Refresh when the TRESTLE Profile changes
• Control product carousels

Commercial rules
----------------
• Natural Solutions → 10% TRESTLE Saving
• Other eligible collections → 5% TRESTLE Saving
• Premium members → Corporate + Individual
• Actual checkout discount remains controlled by Shopify
==============================================================================*/


const TRESTLE_W008 = {


/*==============================================================================
STATE
==============================================================================*/

state: {

    profile: null,

    shopifyProducts: [],

    recommended: [],

    explore: [],

    isPremium: false

},


/*==============================================================================
DOM
==============================================================================*/

ui: {

    root: null,

    shopifyData: null,

    recommendedSection: null,

    recommendedTrack: null,

    recommendedPrev: null,

    recommendedNext: null,

    exploreSection: null,

    exploreTrack: null,

    explorePrev: null,

    exploreNext: null

},


/*==============================================================================
INIT
==============================================================================*/

init(){

    this.cacheDOM();


    if(
        !this.ui.root ||
        !this.ui.shopifyData
    ){

        return;

    }


    this.loadMembership();

    this.loadShopifyProducts();

    this.loadProfile();

    this.render();

    this.bindEvents();


    console.log(
        "TRESTLE W008 Ready"
    );

},


/*==============================================================================
CACHE DOM
==============================================================================*/

cacheDOM(){

    this.ui.root =
        document.getElementById(
            "trW008"
        );


    this.ui.shopifyData =
        document.getElementById(
            "trW008ShopifyProducts"
        );


    this.ui.recommendedSection =
        document.getElementById(
            "trW008RecommendedSection"
        );


    this.ui.recommendedTrack =
        document.getElementById(
            "trW008RecommendedTrack"
        );


    this.ui.recommendedPrev =
        document.getElementById(
            "trW008RecommendedPrev"
        );


    this.ui.recommendedNext =
        document.getElementById(
            "trW008RecommendedNext"
        );


    this.ui.exploreSection =
        document.getElementById(
            "trW008ExploreSection"
        );


    this.ui.exploreTrack =
        document.getElementById(
            "trW008ExploreTrack"
        );


    this.ui.explorePrev =
        document.getElementById(
            "trW008ExplorePrev"
        );


    this.ui.exploreNext =
        document.getElementById(
            "trW008ExploreNext"
        );

},


/*==============================================================================
LOAD MEMBERSHIP

Liquid writes:
data-trestle-premium="true"
or
data-trestle-premium="false"

This prevents W008 from independently guessing membership.
==============================================================================*/

loadMembership(){

    if(!this.ui.root){

        this.state.isPremium = false;

        return;

    }


    this.state.isPremium =

        this.ui.root.dataset.trestlePremium ===
        "true";

},


/*==============================================================================
LOAD SHOPIFY PRODUCTS
==============================================================================*/

loadShopifyProducts(){

    try{

        const raw =
            this.ui.shopifyData.textContent.trim();


        this.state.shopifyProducts =
            raw
            ?
            JSON.parse(raw)
            :
            [];

    }

    catch(error){

        console.warn(
            "W008: Unable to read Shopify product data",
            error
        );


        this.state.shopifyProducts = [];

    }

},


/*==============================================================================
LOAD PROFILE
==============================================================================*/

loadProfile(){

    try{

        const stored =
            localStorage.getItem(
                "trestleProfile"
            );


        this.state.profile =
            stored
            ?
            JSON.parse(stored)
            :
            null;

    }

    catch(error){

        console.warn(
            "W008: Unable to read TRESTLE Profile",
            error
        );


        this.state.profile = null;

    }

},


/*==============================================================================
PROFILE COMPLETE
==============================================================================*/

isProfileComplete(){

    const profile =
        this.state.profile;


    return Boolean(

        profile &&

        profile.promise &&

        profile.lifeStage &&

        profile.diabetesType

    );

},


/*==============================================================================
FIND SHOPIFY PRODUCT
==============================================================================*/

getShopifyProduct(handle){

    return this.state.shopifyProducts.find(

        product =>
            product.handle === handle

    ) || null;

},


/*==============================================================================
CHECK GATE
==============================================================================*/

passesGate(item){

    if(
        !item.gate
    ){

        return true;

    }


    const profile =
        this.state.profile;


    if(!profile){

        return false;

    }


    const profileValue =
        profile[
            item.gate.type
        ];


    return item.gate.values.includes(
        profileValue
    );

},


/*==============================================================================
CALCULATE SCORE
==============================================================================*/

calculateScore(item){

    const profile =
        this.state.profile;


    if(
        !profile ||
        !item ||
        !item.relevance
    ){

        return 0;

    }


    let score = 0;


    if(

        item.relevance.promise.includes(
            profile.promise
        )

    ){

        score +=
            item.weights.promise || 0;

    }


    if(

        item.relevance.lifeStage.includes(
            profile.lifeStage
        )

    ){

        score +=
            item.weights.lifeStage || 0;

    }


    if(

        item.relevance.diabetesType.includes(
            profile.diabetesType
        )

    ){

        score +=
            item.weights.diabetesType || 0;

    }


    return score;

},


/*==============================================================================
BUILD CANDIDATES
==============================================================================*/

buildCandidates(){

    const intelligence =
        Array.isArray(
            window.TRESTLE_W008_PRODUCT_DATA
        )
        ?
        window.TRESTLE_W008_PRODUCT_DATA
        :
        [];


    const candidates = [];


    intelligence.forEach(

        (item,index)=>{

            if(
                !item ||
                item.active !== true
            ){

                return;

            }


            const shopifyProduct =
                this.getShopifyProduct(
                    item.handle
                );


            if(!shopifyProduct){

                return;

            }


            const score =
                this.calculateScore(
                    item
                );


            const gatePassed =
                this.passesGate(
                    item
                );


            candidates.push({

                ...item,

                shopify:
                    shopifyProduct,

                score:
                    score,

                gatePassed:
                    gatePassed,

                originalIndex:
                    index

            });

        }

    );


    return candidates;

},


/*==============================================================================
SORT CANDIDATES
==============================================================================*/

sortCandidates(items){

    return [...items].sort(

        (a,b)=>{

            if(
                b.score !== a.score
            ){

                return b.score - a.score;

            }


            return (
                a.originalIndex -
                b.originalIndex
            );

        }

    );

},


/*==============================================================================
SELECT RECOMMENDATIONS
==============================================================================*/

selectRecommendations(candidates){

    const config =
        window.TRESTLE_W008_CONFIG || {};


    const maxRecommendations =
        config.maxRecommendations || 4;


    const minimumScore =
        config.minimumRecommendationScore || 1;


    const eligible =
        this.sortCandidates(

            candidates.filter(

                item =>

                    item.gatePassed &&

                    item.score >=
                    minimumScore &&

                    item.shopify.available !== false

            )

        );


    if(
        config.preferCategoryDiversity !== true
    ){

        return eligible.slice(
            0,
            maxRecommendations
        );

    }


    return this.applyCategoryDiversity(
        eligible,
        maxRecommendations
    );

},


/*==============================================================================
CATEGORY DIVERSITY
==============================================================================*/

applyCategoryDiversity(
    eligible,
    limit
){

    const selected = [];

    const selectedIds =
        new Set();

    const usedCategories =
        new Set();


    eligible.forEach(

        item => {

            if(
                selected.length >= limit
            ){

                return;

            }


            if(
                usedCategories.has(
                    item.category
                )
            ){

                return;

            }


            selected.push(
                item
            );


            selectedIds.add(
                item.id
            );


            usedCategories.add(
                item.category
            );

        }

    );


    eligible.forEach(

        item => {

            if(
                selected.length >= limit
            ){

                return;

            }


            if(
                selectedIds.has(
                    item.id
                )
            ){

                return;

            }


            selected.push(
                item
            );


            selectedIds.add(
                item.id
            );

        }

    );


    return this.sortCandidates(
        selected
    );

},


/*==============================================================================
BUILD EXPLORE
==============================================================================*/

selectExplore(
    candidates,
    recommended
){

    const recommendedIds =
        new Set(

            recommended.map(
                item => item.id
            )

        );


    return candidates

        .filter(

            item =>
                !recommendedIds.has(
                    item.id
                )

        )

        .sort(

            (a,b)=>{

                if(
                    a.shopify.available !==
                    b.shopify.available
                ){

                    return a.shopify.available
                        ?
                        -1
                        :
                        1;

                }


                if(
                    b.score !== a.score
                ){

                    return b.score - a.score;

                }


                return (
                    a.originalIndex -
                    b.originalIndex
                );

            }

        );

},


/*==============================================================================
BUILD RECOMMENDATION STATE
==============================================================================*/

buildRecommendationState(){

    const candidates =
        this.buildCandidates();


    if(
        !this.isProfileComplete()
    ){

        this.state.recommended = [];

        this.state.explore =
            this.selectExplore(
                candidates,
                []
            );


        return;

    }


    this.state.recommended =
        this.selectRecommendations(
            candidates
        );


    this.state.explore =
        this.selectExplore(
            candidates,
            this.state.recommended
        );

},


/*==============================================================================
FORMAT MONEY
==============================================================================*/

formatMoney(
    amount,
    currency
){

    const numericAmount =
        Number(amount);


    if(
        Number.isNaN(
            numericAmount
        )
    ){

        return "";

    }


    const currencyCode =
        currency || "INR";


    try{

        return new Intl.NumberFormat(

            "en-IN",

            {
                style: "currency",
                currency: currencyCode,
                maximumFractionDigits: 0
            }

        ).format(
            numericAmount / 100
        );

    }

    catch(error){

        return (
            "₹" +
            Math.round(
                numericAmount / 100
            )
        );

    }

},


/*==============================================================================
CALCULATE TRESTLE SPECIAL PRICE

Shopify amounts are supplied in minor currency units.

Example:
₹392 = 39200
10% saving = 35280
Displayed using formatMoney() = ₹353

Actual checkout discount remains Shopify-controlled.
==============================================================================*/

calculateTrestlePrice(
    price,
    savingPercent
){

    const numericPrice =
        Number(price);


    const numericSaving =
        Number(savingPercent);


    if(
        Number.isNaN(numericPrice) ||
        Number.isNaN(numericSaving) ||
        numericSaving <= 0
    ){

        return numericPrice;

    }


    return Math.round(

        numericPrice *
        (
            1 -
            numericSaving / 100
        )

    );

},


/*==============================================================================
CREATE PRODUCT CARD
==============================================================================*/

createProductCard(item){

    const product =
        item.shopify;


    const card =
        document.createElement(
            "article"
        );


    card.className =
        "tr-w008-product-card";


    /*--------------------------------------------------------------------------
    MEMBERSHIP / SAVING
    --------------------------------------------------------------------------*/

    const savingPercent =
        Number(
            product.trestleSavingPercent || 0
        );


    const hasTrestleSaving =
        this.state.isPremium &&
        savingPercent > 0;


    /*--------------------------------------------------------------------------
    IMAGE LINK
    --------------------------------------------------------------------------*/

    const imageLink =
        document.createElement(
            "a"
        );


    imageLink.className =
        "tr-w008-product-image-link";


    imageLink.href =
        product.url;


    imageLink.target =
        "_blank";


    imageLink.rel =
        "noopener noreferrer";


    imageLink.setAttribute(
        "aria-label",
        product.title
    );


    const imageWrap =
        document.createElement(
            "div"
        );


    imageWrap.className =
        "tr-w008-product-image";


    /*--------------------------------------------------------------------------
    TRESTLE SAVING BADGE
    --------------------------------------------------------------------------*/

    if(hasTrestleSaving){

        const badge =
            document.createElement(
                "div"
            );


        badge.className =
            "tr-w008-trestle-saving-badge";


        const badgePercent =
            document.createElement(
                "strong"
            );


        badgePercent.textContent =
            savingPercent + "%";


        const badgeText =
            document.createElement(
                "span"
            );


        badgeText.textContent =
            "TRESTLE SAVING";


        badge.appendChild(
            badgePercent
        );


        badge.appendChild(
            badgeText
        );


        imageWrap.appendChild(
            badge
        );

    }


    if(product.image){

        const image =
            document.createElement(
                "img"
            );


        image.src =
            product.image;


        image.alt =
            product.title;


        image.loading =
            "lazy";


        image.width =
            800;


        image.height =
            800;


        imageWrap.appendChild(
            image
        );

    }


    imageLink.appendChild(
        imageWrap
    );


    card.appendChild(
        imageLink
    );


    /*--------------------------------------------------------------------------
    CONTENT
    --------------------------------------------------------------------------*/

    const content =
        document.createElement(
            "div"
        );


    content.className =
        "tr-w008-product-content";


    /*--------------------------------------------------------------------------
    PRODUCT TITLE
    --------------------------------------------------------------------------*/

    const title =
        document.createElement(
            "h4"
        );


    title.className =
        "tr-w008-product-title";


    title.textContent =
        product.title;


    content.appendChild(
        title
    );


    /*--------------------------------------------------------------------------
    PRICE
    --------------------------------------------------------------------------*/

    const priceWrap =
        document.createElement(
            "div"
        );


    priceWrap.className =
        "tr-w008-product-pricing";


    const currentPrice =
        Number(
            product.price
        );


    const comparePrice =
        Number(
            product.compareAtPrice
        );


    if(

        comparePrice &&

        comparePrice >
        currentPrice

    ){

        const mrp =
            document.createElement(
                "span"
            );


        mrp.className =
            "tr-w008-product-mrp";


        mrp.textContent =
            "MRP " +
            this.formatMoney(
                comparePrice,
                product.currency
            );


        priceWrap.appendChild(
            mrp
        );

    }


    /*--------------------------------------------------------------------------
    DIAFEMME PRICE
    --------------------------------------------------------------------------*/

    const price =
        document.createElement(
            "span"
        );


    price.className =
        "tr-w008-product-price";


    price.textContent =

        comparePrice &&
        comparePrice > currentPrice

        ?

        "Diafemme Price " +
        this.formatMoney(
            currentPrice,
            product.currency
        )

        :

        this.formatMoney(
            currentPrice,
            product.currency
        );


    priceWrap.appendChild(
        price
    );


    /*--------------------------------------------------------------------------
    TRESTLE SPECIAL PRICE

    Visible only to paid Corporate / Individual members and only
    when Liquid marks the product as eligible for a TRESTLE saving.
    --------------------------------------------------------------------------*/

    if(hasTrestleSaving){

        const specialPrice =
            this.calculateTrestlePrice(
                currentPrice,
                savingPercent
            );


        const special =
            document.createElement(
                "span"
            );


        special.className =
            "tr-w008-trestle-special-price";


        special.textContent =
            "TRESTLE Special Price " +
            this.formatMoney(
                specialPrice,
                product.currency
            );


        priceWrap.appendChild(
            special
        );


        const delivery =
            document.createElement(
                "span"
            );


        delivery.className =
            "tr-w008-trestle-delivery";


        delivery.textContent =
            "Free Delivery";


        priceWrap.appendChild(
            delivery
        );

    }


    content.appendChild(
        priceWrap
    );


    /*--------------------------------------------------------------------------
    BUY NOW
    --------------------------------------------------------------------------*/

    const button =
        document.createElement(
            "a"
        );


    button.className =
        "tr-w008-buy-button";


    button.href =
        product.url;


    button.target =
        "_blank";


    button.rel =
        "noopener noreferrer";


    if(
        product.available === false
    ){

        button.textContent =
            "Currently Unavailable";


        button.classList.add(
            "is-unavailable"
        );


        button.setAttribute(
            "aria-disabled",
            "true"
        );


        button.addEventListener(

            "click",

            event => {

                event.preventDefault();

            }

        );

    }

    else{

        button.textContent =
            "Buy Now";

    }


    content.appendChild(
        button
    );


    card.appendChild(
        content
    );


    return card;

},


/*==============================================================================
RENDER TRACK
==============================================================================*/

renderTrack(
    track,
    items
){

    if(!track){

        return;

    }


    track.innerHTML = "";


    items.forEach(

        item => {

            track.appendChild(
                this.createProductCard(
                    item
                )
            );

        }

    );

},


/*==============================================================================
RENDER
==============================================================================*/

render(){

    this.buildRecommendationState();


    if(
        this.state.recommended.length
    ){

        this.ui.recommendedSection.hidden =
            false;


        this.renderTrack(

            this.ui.recommendedTrack,

            this.state.recommended

        );

    }

    else{

        this.ui.recommendedSection.hidden =
            true;


        if(
            this.ui.recommendedTrack
        ){

            this.ui.recommendedTrack.innerHTML =
                "";

        }

    }


    if(
        this.state.explore.length
    ){

        this.ui.exploreSection.hidden =
            false;


        this.renderTrack(

            this.ui.exploreTrack,

            this.state.explore

        );

    }

    else{

        this.ui.exploreSection.hidden =
            true;


        if(
            this.ui.exploreTrack
        ){

            this.ui.exploreTrack.innerHTML =
                "";

        }

    }

},


/*==============================================================================
SCROLL CAROUSEL
==============================================================================*/

scrollTrack(
    track,
    direction
){

    if(!track){

        return;

    }


    const card =
        track.querySelector(
            ".tr-w008-product-card"
        );


    if(!card){

        return;

    }


    const gap = 18;


    const distance =
        card.getBoundingClientRect().width +
        gap;


    track.parentElement.scrollBy({

        left:
            distance *
            direction,

        behavior:
            "smooth"

    });

},


/*==============================================================================
REFRESH PROFILE
==============================================================================*/

refreshProfile(){

    this.loadProfile();

    this.render();

},


/*==============================================================================
BIND EVENTS
==============================================================================*/

bindEvents(){

    if(
        this.ui.recommendedPrev
    ){

        this.ui.recommendedPrev.addEventListener(

            "click",

            ()=>{

                this.scrollTrack(
                    this.ui.recommendedTrack,
                    -1
                );

            }

        );

    }


    if(
        this.ui.recommendedNext
    ){

        this.ui.recommendedNext.addEventListener(

            "click",

            ()=>{

                this.scrollTrack(
                    this.ui.recommendedTrack,
                    1
                );

            }

        );

    }


    if(
        this.ui.explorePrev
    ){

        this.ui.explorePrev.addEventListener(

            "click",

            ()=>{

                this.scrollTrack(
                    this.ui.exploreTrack,
                    -1
                );

            }

        );

    }


    if(
        this.ui.exploreNext
    ){

        this.ui.exploreNext.addEventListener(

            "click",

            ()=>{

                this.scrollTrack(
                    this.ui.exploreTrack,
                    1
                );

            }

        );

    }


    window.addEventListener(

        "trestle-profile-updated",

        ()=>{

            this.refreshProfile();

        }

    );


    document.addEventListener(

        "trestle:profile-updated",

        ()=>{

            this.refreshProfile();

        }

    );

},


/*==============================================================================
PUBLIC REFRESH
==============================================================================*/

refresh(){

    this.loadMembership();

    this.loadShopifyProducts();

    this.refreshProfile();

}


/*==============================================================================
END W008
==============================================================================*/

};


/*==============================================================================
BOOTSTRAP
==============================================================================*/

document.addEventListener(

    "DOMContentLoaded",

    ()=>{

        TRESTLE_W008.init();

    }

);


/*==============================================================================
PUBLIC API
==============================================================================*/

window.TRESTLE_W008 =
    TRESTLE_W008;